import { useContext, useEffect, useState } from 'react'
import { UIContext } from 'Context/UI'
import { useNavigate, useParams } from 'react-router-dom'
import { useProductionStore } from 'Store/Production'
import { useProductLineStore } from 'Store/ProductLine'
import { useCallbackPrompt } from 'Hooks/useCallbackPrompt'
import { shallow } from 'zustand/shallow'
import { generateImageUrl } from 'Utils/generateImageUrl'
import Swal from 'sweetalert2'
import { toast } from 'react-toastify'

const ViewModel = () => {
	const { id } = useParams()
	const navigate = useNavigate()
	const { setCustomContentToolbar, setShowContentToolbar } = useContext(UIContext)
	const { getProperties, submit } = useProductionStore(
		state => ({
			productProperties: state.productProperties,
			getProperties: state.getProperties,
			submit: state.submit,
		}),
		shallow
	)
	const { getOneWithProperties, clearStateOptions } = useProductLineStore(
		state => ({
			selectedWithProperties: state.selectedWithProperties,
			getOneWithProperties: state.getOneWithProperties,
			clearStateOptions: state.clearState,
		}),
		shallow
	)
	const { getOneWithChildren, getProducts } = useProductLineStore(
		state => ({
			selectedWithChildren: state.selectedWithChildren,
			getOneWithChildren: state.getOneWithChildren,
			getProducts: state.getProducts,
		}),
		shallow
	)
	const [isLoading, setIsLoading] = useState(false)
	const [hasChanged, setHasChanged] = useState(false)
	const [disabledSubmitButton, setDisabledSubmitButton] = useState(false)

	useCallbackPrompt(hasChanged)

	const [minimumOrder, setMinimumOrder] = useState<any>('')
	const [mappedProducts, setMappedProducts] = useState<any[]>([])
	const [mappedOptions, setMappedOptions] = useState<any[]>([])
	const [mappedAccessories, setMappedAccessories] = useState<any[]>([])
	const [mappedThicknesses, setMappedThicknesses] = useState<any[]>([])
	const [mappedOuterMaterials, setMappedOuterMaterials] = useState<any[]>([])
	const [mappedInnerMaterials, setMappedInnerMaterials] = useState<any[]>([])
	const [mappedPrintingOptions, setMappedPrintingOptions] = useState<any[]>([])
	const [mappedFormings, setMappedFormings] = useState<any[]>([])

	const mappingData = async (
		_properties: {
			minimumOrder: number
			products: { supplierId: number; productId: number }[]
			options: { supplierId: number; taxonomyId: number }[]
			accessories: { supplierId: number; taxonomyId: number }[]
			thicknesses: { supplierId: number; taxonomyId: number }[]
			outerMaterials: { supplierId: number; taxonomyId: number }[]
			innerMaterials: { supplierId: number; taxonomyId: number }[]
			printingOptions: { supplierId: number; taxonomyId: number }[]
			formings: { supplierId: number; taxonomyId: number }[]
		},
		_products: any[],
		_options: any[],
		_accessories: any[],
		_thicknesses: any[],
		_outerMaterials: any[],
		_innerMaterials: any[],
		_printingOptions: any[],
		_formings: any[]
	) => {
		const {
			products,
			options,
			accessories,
			thicknesses,
			outerMaterials,
			innerMaterials,
			printingOptions,
			formings,
		} = _properties

		setMinimumOrder(_properties.minimumOrder)

		setMappedProducts(
			_products.map((o: any) => {
				// @ts-ignore
				const finded = products.find((p: any) => parseInt(p.productId) === parseInt(o.id))

				return {
					...o,
					featurePicturePath: o.featurePicturePath
						? generateImageUrl(o.featurePicturePath)
						: undefined,
					active: finded !== undefined,
				}
			})
		)
		setMappedOptions(
			_options.map((o: any) => {
				// @ts-ignore
				const finded = options.find((p: any) => parseInt(p.taxonomyId) === parseInt(o.id))

				return {
					...o,
					featurePicturePath: o.featurePicturePath
						? generateImageUrl(o.featurePicturePath)
						: undefined,
					active: finded !== undefined,
				}
			})
		)
		setMappedAccessories(
			_accessories.map((o: any) => {
				// @ts-ignore
				const finded = accessories.find((p: any) => parseInt(p.taxonomyId) === parseInt(o.id))

				return {
					...o,
					featurePicturePath: o.featurePicturePath
						? generateImageUrl(o.featurePicturePath)
						: undefined,
					active: finded !== undefined,
				}
			})
		)
		setMappedThicknesses(
			_thicknesses.map((o: any) => {
				// @ts-ignore
				const finded = thicknesses.find((p: any) => parseInt(p.taxonomyId) === parseInt(o.id))

				return {
					...o,
					featurePicturePath: o.featurePicturePath
						? generateImageUrl(o.featurePicturePath)
						: undefined,
					active: finded !== undefined,
				}
			})
		)
		setMappedOuterMaterials(
			_outerMaterials.map((o: any) => {
				// @ts-ignore
				const finded = outerMaterials.find((p: any) => parseInt(p.taxonomyId) === parseInt(o.id))

				return {
					...o,
					isColor: true,
					featurePicturePath: o.featurePicturePath
						? generateImageUrl(o.featurePicturePath)
						: undefined,
					active: finded !== undefined,
				}
			})
		)
		setMappedInnerMaterials(
			_innerMaterials.map((o: any) => {
				// @ts-ignore
				const finded = innerMaterials.find((p: any) => parseInt(p.taxonomyId) === parseInt(o.id))

				return {
					...o,
					isColor: true,
					featurePicturePath: o.featurePicturePath
						? generateImageUrl(o.featurePicturePath)
						: undefined,
					active: finded !== undefined,
				}
			})
		)
		setMappedPrintingOptions(
			_printingOptions.map((o: any) => {
				// @ts-ignore
				const finded = printingOptions.find((p: any) => parseInt(p.taxonomyId) === parseInt(o.id))

				return {
					...o,
					featurePicturePath: o.featurePicturePath
						? generateImageUrl(o.featurePicturePath)
						: undefined,
					active: finded !== undefined,
				}
			})
		)
		setMappedFormings(
			_formings.map((o: any) => {
				// @ts-ignore
				const finded = formings.find((p: any) => parseInt(p.taxonomyId) === parseInt(o.id))

				return {
					...o,
					featurePicturePath: o.featurePicturePath
						? generateImageUrl(o.featurePicturePath)
						: undefined,
					active: finded !== undefined,
				}
			})
		)
	}

	const fetchData = () => {
		if (id) {
			setIsLoading(true)

			const parsedId = parseInt(id)
			getOneWithChildren(parsedId).then(({ success, data }) => {
				if (!success) {
					Swal.fire({
						icon: 'error',
						title: 'เกิดข้อผิดพลาด',
						text: data,
						confirmButtonText: 'ปิด',
						customClass: {
							confirmButton: 'btn btn-sm btn-kumopack-primary-600 text-kumopack-base-white',
						},
					}).then(() => {
						navigate('/general/production')
					})
					return
				} else {
					getProperties(parsedId).then(({ success: successProperties, data: dataProperties }) => {
						if (!successProperties) {
							Swal.fire({
								icon: 'error',
								title: 'เกิดข้อผิดพลาด',
								text: dataProperties,
								confirmButtonText: 'ปิด',
								customClass: {
									confirmButton: 'btn btn-sm btn-kumopack-primary-600 text-kumopack-base-white',
								},
							}).then(() => {
								navigate('/general/production')
							})
							return
						}

						Promise.all([
							getOneWithProperties(data?.parentId ?? parsedId),
							getProducts(parsedId),
						]).then(
							([
								{ success: successMasterProperties, data: dataMasterProperties },
								{ success: successMasterProducts, data: dataMasterProducts },
							]) => {
								if (!successMasterProperties || !successMasterProducts) {
									Swal.fire({
										icon: 'error',
										title: 'เกิดข้อผิดพลาด',
										text: 'ไม่สามารถดึงข้อมูลได้',
										confirmButtonText: 'ปิด',
										customClass: {
											confirmButton: 'btn btn-sm btn-kumopack-primary-600 text-kumopack-base-white',
										},
									}).then(() => {
										navigate('/general/production')
									})

									return
								} else {
									mappingData(
										dataProperties,
										dataMasterProducts,
										dataMasterProperties.options,
										dataMasterProperties.accessories,
										dataMasterProperties.thicknesses,
										dataMasterProperties.outerMaterials,
										dataMasterProperties.innerMaterials,
										dataMasterProperties.printingOptions,
										dataMasterProperties.formings
									).then(() => {
										setIsLoading(false)
									})
								}
							}
						)
					})
				}
			})
		}
	}

	const handleSelectItem = (
		category:
			| 'product'
			| 'option'
			| 'accessory'
			| 'thickness'
			| 'outer-material'
			| 'inner-material'
			| 'printing-option'
			| 'forming',
		idx: number,
		active: boolean
	) => {
		switch (category) {
			case 'product': {
				setMappedProducts(prevState =>
					prevState.map((item, itemIdx) => (itemIdx === idx ? { ...item, active } : item))
				)
				setHasChanged(true)
				break
			}
			case 'option': {
				setMappedOptions(prevState =>
					prevState.map((item, itemIdx) => (itemIdx === idx ? { ...item, active } : item))
				)
				setHasChanged(true)
				break
			}
			case 'accessory': {
				setMappedAccessories(prevState =>
					prevState.map((item, itemIdx) => (itemIdx === idx ? { ...item, active } : item))
				)
				setHasChanged(true)
				break
			}
			case 'thickness': {
				setMappedThicknesses(prevState =>
					prevState.map((item, itemIdx) => (itemIdx === idx ? { ...item, active } : item))
				)
				setHasChanged(true)
				break
			}
			case 'outer-material': {
				setMappedOuterMaterials(prevState =>
					prevState.map((item, itemIdx) => (itemIdx === idx ? { ...item, active } : item))
				)
				setHasChanged(true)
				break
			}
			case 'inner-material': {
				setMappedInnerMaterials(prevState =>
					prevState.map((item, itemIdx) => (itemIdx === idx ? { ...item, active } : item))
				)
				setHasChanged(true)
				break
			}
			case 'printing-option': {
				setMappedPrintingOptions(prevState =>
					prevState.map((item, itemIdx) => (itemIdx === idx ? { ...item, active } : item))
				)
				setHasChanged(true)
				break
			}
			case 'forming': {
				setMappedFormings(prevState =>
					prevState.map((item, itemIdx) => (itemIdx === idx ? { ...item, active } : item))
				)
				setHasChanged(true)
				break
			}
			default: {
				break
			}
		}
	}

	const onFillMinimumOrder: React.ChangeEventHandler<HTMLInputElement> = e => {
		// check if input is number
		const re = /^[0-9\b]+$/
		if (e.target.value === '' || re.test(e.target.value)) {
			setMinimumOrder(e.target.value)
			setHasChanged(true)
		}
	}

	const cancel = () => {
		navigate('/general/production')
	}

	const save = () => {
		if (hasChanged && id) {
			setDisabledSubmitButton(true)

			if (minimumOrder.length === 0) {
				toast.error('กรุณากรอกจำนวนสั่งขั้นต่ำ')
				setDisabledSubmitButton(false)
			}

			const products = mappedProducts.filter(o => o.active).map(o => parseInt(o.id))
			const options = mappedOptions.filter(o => o.active).map(o => parseInt(o.id))
			const accessories = mappedAccessories.filter(o => o.active).map(o => parseInt(o.id))
			const thicknesses = mappedThicknesses.filter(o => o.active).map(o => parseInt(o.id))
			const outerMaterials = mappedOuterMaterials.filter(o => o.active).map(o => parseInt(o.id))
			const innerMaterials = mappedInnerMaterials.filter(o => o.active).map(o => parseInt(o.id))
			const printingOptions = mappedPrintingOptions.filter(o => o.active).map(o => parseInt(o.id))
			const formings = mappedFormings.filter(o => o.active).map(o => parseInt(o.id))

			if (products.length === 0) {
				toast.error('กรุณาเลือกสินค้า')
				setDisabledSubmitButton(false)
				return
			}
			if (
				options.length === 0 &&
				accessories.length === 0 &&
				thicknesses.length === 0 &&
				outerMaterials.length === 0 &&
				innerMaterials.length === 0 &&
				printingOptions.length === 0 &&
				formings.length === 0
			) {
				toast.error('กรุณาเลือกตัวเลือก')
				setDisabledSubmitButton(false)
				return
			}

			const body = {
				minimumOrder,
				productLineId: parseInt(id),
				products,
				options,
				accessories,
				thicknesses,
				outerMaterials,
				innerMaterials,
				printingOptions,
				formings,
			}

			submit(body).then(({ success, data }) => {
				if (!success) {
					Swal.fire({
						title: 'บันทึกไม่สำเร็จ',
						text: data,
						icon: 'error',
						customClass: {
							confirmButton: 'btn btn-sm btn-kumopack-primary-600 text-kumopack-base-white',
						},
						confirmButtonText: 'ตกลง',
					}).then(() => {
						setDisabledSubmitButton(false)
					})
				} else {
					setHasChanged(false)
					Swal.fire({
						title: 'บันทึกข้อมูลสำเร็จ',
						text: 'บันทึกรายการสร้างสินค้าเสร็จสิ้น',
						icon: 'success',
						customClass: {
							confirmButton: 'btn btn-sm btn-kumopack-primary-600 text-kumopack-base-white',
						},
						confirmButtonText: 'ตกลง',
					}).then(() => {
						navigate('/general/production')
					})
				}
			})
		}
	}

	// Toolbar
	useEffect(() => {
		setShowContentToolbar(false)
		setCustomContentToolbar(null)

		return () => {
			setShowContentToolbar(true)
			setCustomContentToolbar(null)
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	useEffect(() => {
		fetchData()
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [id])

	useEffect(() => {
		return () => {
			clearStateOptions()
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	return {
		// Status
		isLoading,
		disabledSubmitButton,
		// Data
		mappedProducts,
		mappedOptions,
		mappedAccessories,
		mappedThicknesses,
		mappedOuterMaterials,
		mappedInnerMaterials,
		mappedPrintingOptions,
		mappedFormings,
		minimumOrder,
		// Function
		handleSelectItem,
		cancel,
		save,
		onFillMinimumOrder,
	}
}

export default ViewModel
